import request from '@/utils/http'

export function getCategory(data) {
  return request({
    url: 'category.get',
    method: 'get',
    params: data
  })
}

export function categoryAdd(data) {
  return request({
    url: 'category.post',
    method: 'post',
    data,
    auth: true
  })
}

export function categoryDel(data) {
  return request({
    url: 'category.delete',
    method: 'post',
    data,
    auth: true
  })
}
